import {useEffect} from 'react';
import {useSearchParams} from 'react-router';
import useSourcesExplorerStore from '../reportEditorPage/leftPanel/components/useSourcesExplorerStore';

export function useInitSourcesExplorer() {
    const [searchParams] = useSearchParams();
    const initFromUrl = useSourcesExplorerStore((s) => s.initFromUrl);
    const initialized = useSourcesExplorerStore((s) => s._initialized);

    useEffect(() => {
        if (!initialized) {
            initFromUrl(searchParams);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialized, initFromUrl]);
}

